<template>
  <div>
    <h1>{{ $t("setIoCard") }}</h1>
    <div class="zone-top" ref="midBox">
      <span style="float: left">
        <span class="label">{{ this.$t("IOBoard") }}:</span>
        <el-select v-model="IoCard" style="width: 110px;" @change="change">
          <el-option :label="$t('all')" :value="0"> </el-option>
          <el-option :label="1" :value="1"> </el-option>
          <el-option :label="2" :value="2"> </el-option>
          <el-option :label="3" :value="3"> </el-option>
          <el-option :label="4" :value="4"> </el-option>
        </el-select>
      </span>
      <el-button
        class="blue-btn save-btn"
        style="position: relative; top: -6px"
        @click="saveAll"
        >{{ $t("save") }}</el-button
      >
    </div>
    <el-scrollbar style="width: 100%">
      <Table
        style="width: 100%;margin-bottom: 5px"
        v-if="height"
        ref="tableRef"
        :dataSource="dataSource"
        :columns="tableColumns"
        :height="height"
      >
        <template #Func>
          <el-table-column :label="$t('Func')">
            <template slot-scope="scope">
              <el-select v-model="scope.row.Func" style="width: 110px;">
                <el-option :label="$t('none')" :value="0"> </el-option>
                <el-option :label="$t('Alarm')" :value="1"> </el-option>
                <el-option :label="$t('Fault')" :value="2"> </el-option>
                <el-option
                  v-if="!(scope.$index == 4 || scope.$index == 5)"
                  :label="$t('Output')"
                  :value="3"
                >
                </el-option>
                <el-option v-else :label="$t('Feedback')" :value="3">
                </el-option>
                <el-option
                  v-if="!scope.$index"
                  :label="$t('RTFAULT')"
                  :value="4"
                >
                </el-option>
              </el-select>
            </template>
          </el-table-column>
        </template>
        <template #allowedMaxLoad>
          <el-table-column :label="$t('allowedMaxLoad')">
            <template slot-scope="scope">
              <el-select
                v-model="scope.row.allowedMaxLoad"
                style="width: 110px;"
                v-if="!(scope.$index == 4 || scope.$index == 5)"
              >
                <el-option label="0.5A" :value="0"> </el-option>
                <el-option label="0.3A" :value="1"> </el-option>
                <el-option label="0.1A" :value="2"> </el-option>
                <el-option label="0.05A" :value="3"> </el-option>
              </el-select>
            </template>
          </el-table-column>
        </template>
        <template #FaultCheck>
          <el-table-column :label="$t('FaultCheck')">
            <template slot-scope="scope">
              <el-select v-model="scope.row.FaultCheck" style="width: 110px;">
                <el-option label="EN54-2" :value="0"> </el-option>
                <el-option label="EN54-13" :value="1"> </el-option>
              </el-select>
            </template>
          </el-table-column>
        </template>
        <template #classA>
          <el-table-column :label="$t('classA')">
            <template slot-scope="scope">
              <el-select v-model="scope.row.classA" style="width: 110px;">
                <el-option :label="$t('no')" :value="0"> </el-option>
                <el-option :label="$t('yes')" :value="1"> </el-option>
              </el-select>
            </template>
          </el-table-column>
        </template>
        <template #groupZone>
          <el-table-column :label="'Group/Zone'">
            <template slot-scope="scope">
              <el-input-number
                v-if="!(scope.$index == 4 || scope.$index == 5)"
                v-model="scope.row.group"
                :min="0"
                :max="400"
                :controls="false"
                style="width: 80px;"
              >
              </el-input-number>
              <el-input-number
                v-else
                v-model="scope.row.zone"
                :min="0"
                :max="400"
                :controls="false"
                style="width: 80px;"
              >
              </el-input-number>
            </template>
          </el-table-column>
        </template>
      </Table>
    </el-scrollbar>
  </div>
</template>

<script>
import { getPanelDetail, setPanelIoCard } from "../../api/panel";

export default {
  name: "setIoCard",
  data() {
    return {
      dataSource: [
        {
          loop: 1,
          Func: 3, // Bit 0-1 0无，1火警
          allowedMaxLoad: 0, //
          FaultCheck: 1,
          classA: 1,
          group: 0
        },
        {
          loop: 2,
          Func: 2,
          allowedMaxLoad: 0,
          FaultCheck: 0,
          classA: 0,
          group: 0
        },
        {
          loop: 3,
          Func: 2,
          allowedMaxLoad: 0,
          FaultCheck: 0,
          classA: 0,
          group: 0
        },
        {
          loop: 4,
          Func: 2,
          allowedMaxLoad: 0,
          FaultCheck: 0,
          classA: 0,
          group: 0
        },
        {
          loop: 5,
          Func: 2,
          allowedMaxLoad: 0,
          FaultCheck: 0,
          classA: 0,
          zone: 0
        },
        {
          loop: 6,
          Func: 2,
          allowedMaxLoad: 0,
          FaultCheck: 0,
          classA: 0,
          zone: 0
        }
      ],
      tableColumns: [
        {
          prop: "loop",
          label: this.$t("channel")
        },
        {
          prop: "groupZone",
          label: "Group/Zone",
          slotName: "groupZone"
        },
        {
          prop: "Func",
          label: this.$t("Func"),
          slotName: "Func"
        },
        {
          prop: "allowedMaxLoad",
          label: this.$t("allowedMaxLoad"),
          slotName: "allowedMaxLoad"
        },
        {
          prop: "FaultCheck",
          label: this.$t("FaultCheck"),
          slotName: "FaultCheck"
        },
        {
          prop: "classA",
          label: this.$t("classA"),
          slotName: "classA"
        }
      ],
      setIoCard: [],
      height: "",
      panelId: this.$route.query.panelId,
      panelNo: this.$route.query.panelNo,
      projectId: this.$route.query.projectId,
      IoCard: 1
    };
  },
  mounted() {
    const height =
      window.innerHeight - this.$refs.midBox.getBoundingClientRect().top - 114;
    this.height = height < 200 ? 200 : height;
    this.getPanelDetail();
  },
  methods: {
    getPanelDetail() {
      getPanelDetail({
        panelId: this.panelId,
        projectId: this.projectId
      }).then(res => {
        if (res.code == 1 && res.data.setIoCard) {
          this.setIoCard = JSON.parse(res.data.setIoCard);
          this.selectedIOCard(0);
        }
      });
    },
    saveAll() {
      let setIoCard = [];
      if (this.IoCard) {
        this.setIoCard[this.IoCard - 1] = this.IoCardParams(this.IoCard)[0];
        setIoCard = this.setIoCard;
      } else {
        setIoCard = [
          ...this.IoCardParams(1),
          ...this.IoCardParams(2),
          ...this.IoCardParams(3),
          ...this.IoCardParams(4)
        ];
      }
      setPanelIoCard({
        setIoCard: JSON.stringify(setIoCard),
        panelNo: this.panelNo,
        projectId: this.projectId
      }).then(res => {
        if (res.code == 1) {
          this.$message.success(this.$t("saveSuccess"));
          if (!this.IoCard) this.getPanelDetail();
        }
      });
    },
    // 将表格每一条转为二进制 并将二进制转为十进制返回
    toBinaryFun(data) {
      let arr = [];
      for (let key in data) {
        if (key == "Func") {
          arr = [...this.convertToBinary(data[key]).split(""), ...arr];
        } else if (key == "allowedMaxLoad") {
          arr = [...this.convertToBinary(data[key]).split(""), ...arr];
        } else if (key == "FaultCheck") {
          arr = [data[key] + "", ...arr];
        } else if (key == "classA") {
          arr = [data[key] + "", ...arr];
        }
      }
      return parseInt(arr.join(",").replace(/,/g, ""), 2);
    },
    convertToBinary(num, length = 3) {
      // num 要转二进制的数
      //length 要保留的位数
      var str = num.toString(2);
      let strCopy = num.toString(2);
      //length - str.length 差几位补几0
      for (let i = 0; i < length - str.length; i++) {
        strCopy = "0" + strCopy;
      }
      return strCopy;
    },
    IoCardParams(IoCard) {
      let arr = [];
      let params2 = { IoCard };
      this.dataSource.forEach((item, index) => {
        params2[`loop${index + 1}`] = this.toBinaryFun(item);
      });
      // 添加 group1~4 (loop1-4的输出通道分配) 和 zone5~6 (loop5-6的输入通道分配)
      params2["group1"] = this.dataSource[0].group || 0;
      params2["group2"] = this.dataSource[1].group || 0;
      params2["group3"] = this.dataSource[2].group || 0;
      params2["group4"] = this.dataSource[3].group || 0;
      params2["zone5"] = this.dataSource[4].zone || 0;
      params2["zone6"] = this.dataSource[5].zone || 0;
      arr.push(params2);
      return arr;
    },
    //将一条数字 转为二进制 在转为十进制 并赋值给表格
    toDecimalFun(num, key) {
      let str = this.convertToBinary(num, 8);
      let arr = str.split("");
      if (key == "Func") {
        let flag = arr.splice(5, 3).join("");
        if (flag == "000") {
          return parseInt(parseInt(flag), 2);
        } else {
          return parseInt(flag.replace(/\b(0+)/gi, ""), 2);
        }
      } else if (key == "allowedMaxLoad") {
        let flag = arr.splice(2, 3).join("");
        if (flag == "000") {
          return parseInt(parseInt(flag), 2);
        } else {
          return parseInt(flag.replace(/\b(0+)/gi, ""), 2);
        }
      } else if (key == "FaultCheck") {
        return parseInt(arr[1]);
      } else if (key == "classA") {
        return parseInt(arr[0]);
      }
    },
    selectedIOCard(cardIndex) {
      this.IoCard = this.setIoCard[cardIndex].IoCard; //默认选中第一项
      this.dataSource.forEach((item, index) => {
        item.Func = this.toDecimalFun(
          this.setIoCard[cardIndex][`loop${index + 1}`],
          "Func"
        );
        item.allowedMaxLoad = this.toDecimalFun(
          this.setIoCard[cardIndex][`loop${index + 1}`],
          "allowedMaxLoad"
        );
        item.FaultCheck = this.toDecimalFun(
          this.setIoCard[cardIndex][`loop${index + 1}`],
          "FaultCheck"
        );
        item.classA = this.toDecimalFun(
          this.setIoCard[cardIndex][`loop${index + 1}`],
          "classA"
        );
      });
      // 加载 group1~4 和 zone5~6
      this.dataSource[0].group = this.setIoCard[cardIndex]["group1"] || 0;
      this.dataSource[1].group = this.setIoCard[cardIndex]["group2"] || 0;
      this.dataSource[2].group = this.setIoCard[cardIndex]["group3"] || 0;
      this.dataSource[3].group = this.setIoCard[cardIndex]["group4"] || 0;
      this.dataSource[4].zone = this.setIoCard[cardIndex]["zone5"] || 0;
      this.dataSource[5].zone = this.setIoCard[cardIndex]["zone6"] || 0;
    },
    change(i) {
      if (i == 0) {
        //展示默认值
        this.dataSource = [
          {
            loop: 1,
            Func: 0,
            allowedMaxLoad: 0, //
            FaultCheck: 0,
            classA: 0,
            group: 0
          },
          {
            loop: 2,
            Func: 0,
            allowedMaxLoad: 0,
            FaultCheck: 0,
            classA: 0,
            group: 0
          },
          {
            loop: 3,
            Func: 0,
            allowedMaxLoad: 0,
            FaultCheck: 0,
            classA: 0,
            group: 0
          },
          {
            loop: 4,
            Func: 0,
            allowedMaxLoad: 0,
            FaultCheck: 0,
            classA: 0,
            group: 0
          },
          {
            loop: 5,
            Func: 0,
            allowedMaxLoad: 0,
            FaultCheck: 0,
            classA: 0,
            zone: 0
          },
          {
            loop: 6,
            Func: 0,
            allowedMaxLoad: 0,
            FaultCheck: 0,
            classA: 0,
            zone: 0
          }
        ];
      } else {
        this.selectedIOCard(i - 1);
      }
    }
  }
};
</script>

<style lang="less" scope>
.zone-top {
  text-align: right;
  margin: 10px 0;
  // i {
  //   font-size: 30px;
  //   margin: 0 10px;
  //   cursor: pointer;
  // }
}
.icon-baocun,
.icon-bianji {
  margin-left: 15px;
}
.active {
  color: @color-blue;
}
.save-btn {
  position: relative;
  margin-left: 20px;
}
h1 {
  font-size: 24px;
  font-weight: 400;
}
.item {
  margin-left: 20px;
}
.label {
  padding-right: 10px;
}
.operate {
  i {
    font-size: 30px;
    margin: 0 10px;
    cursor: pointer;
  }
}
</style>
